import React from "react";
import CloseSvg from "../../../images/close.svg";
import DownloadSvg from "../../../images/download.svg";
import AddSvg from "../../../images/add.svg";
import DescSvg from "../../../images/sticky.svg";
import * as utilities from "../../../utilities/utils";

const AttachmentTable = (props) => {
  const validFileName = (fileName) => {
    if (fileName && fileName.length) {
      if (fileName.split(".")[0].length >= 20) {
        fileName = `${fileName.slice(0, 21)}...${fileName.split(".")[1]}`;
      }
    }
    return fileName;
  };

  return (
    <table className="table table-striped">
      <thead>
        <tr>
          <th scope="col">#</th>
          <th scope="col">Name</th>
          <th scope="col">Type</th>
          <th scope="col">Size</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        {props.attachment.map((attachment, index) => (
          <tr key={attachment.fullFilePath}>
            <th scope="row">{index + 1}</th>
            <td>
              {validFileName(attachment.fileName)}
              <br />
              {attachment.attachmentDescription &&
                <small>
                  Description: &nbsp;
                  {attachment.attachmentDescription}
                </small>
              }
            </td>
            <td>{attachment.format}</td>
            <td>{attachment.size}</td>

            <td>
              <a onClick={() => 
                // props.download(attachment.fullFilePath)
                utilities.download(attachment.fullFilePath)
                }>
                <img src={DownloadSvg} className="cursor-pointer" alt="" />
              </a>
              &nbsp;
              <a
                onClick={() =>
                  props.removeFile(
                    attachment.fullFilePath,
                    attachment.isDocs,
                    index,
                    props.attachment
                  )
                }
                className="remove-icon"
              >
                <img src={CloseSvg} className="cursor-pointer" alt="" />
              </a>
              <button
                onClick={() => {
                  props.addDescription(
                    index,
                    attachment.attachmentDescription,
                    props.attachment
                  );
                }}
                className="cursor-pointer btn-edit-desc"
              >
                Edit Desc
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
export default AttachmentTable;
